interface IconProps {
  height: number;
}

export default function StyleDictionary({ height }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      fill="none"
      viewBox="0 0 33 33"
    >
      <path
        fill="#3FC5BF"
        d="M19.011 19.95c-.076-.012-.166-.038-.242-.038H6.877l.115-1.786c.51.166 1.034.23 1.57.166 2.092-.268 3.355-2.59 2.45-4.504a3.318 3.318 0 00-1.557-1.57c.293-.357.574-.714.88-1.059a13.231 13.231 0 012.667-2.169 13.052 13.052 0 012.883-1.301 13.028 13.028 0 013.777-.574c1.71.012 3.368.319 4.95.995 3.025 1.301 5.245 3.458 6.66 6.43.626 1.315.97 2.705 1.124 4.147.012.128.038.243.05.37v.842H20.199c.14.039.293.064.434.077 1.34.191 2.488.778 3.457 1.697.46.434.83.931 1.136 1.48.549.982.817 2.016.817 3.139H19.98c.817-.217 1.289-.945 1.263-1.595 0-.88-.714-1.595-1.595-1.595v-3.215c-.242.038-.446.05-.638.063z"
      ></path>
      <path
        fill="#7FD8D4"
        d="M26.042 26.317a6.263 6.263 0 00-.817-3.139 6.432 6.432 0 00-1.136-1.48c-.982-.918-2.13-1.505-3.457-1.697-.14-.025-.294-.038-.434-.076h12.249v.676l-.039.115c-.05.472-.089.957-.166 1.416a12.043 12.043 0 01-1.084 3.381 12.815 12.815 0 01-5.946 5.933c-1.02.485-2.08.842-3.19 1.047-.331.063-.663.089-.995.127.064-.025.115-.064.179-.09 1.442-.37 2.628-1.135 3.521-2.309a6.349 6.349 0 001.315-3.904z"
      ></path>
      <path
        fill="#1FBBB4"
        d="M20.287 32.684c-.217.013-.42.026-.638.026v-3.19c1.774.012 3.215-1.468 3.203-3.203h3.19a6.256 6.256 0 01-1.327 3.904c-.906 1.174-2.08 2.004-3.522 2.36-.064.014-.727.09-.906.103z"
      ></path>
      <path
        fill="#3FC5BF"
        d="M19.65 29.507v3.19c-.218 0-.422 0-.639-.013-.191-.026-.37-.064-.561-.102-2.629-.498-4.67-2.565-5.104-5.193-.064-.357-.064-.727-.09-1.085h3.19c0 1.761 1.43 3.203 3.203 3.203z"
      ></path>
      <path
        fill="#7FD8D4"
        d="M6.98 18.126l-.115 1.786H.447c.05-4.644 1.505-8.791 4.504-12.313C8.778 3.095 13.703.863 19.649.71v6.406a12.61 12.61 0 00-3.777.574c-1.008.306-1.977.74-2.883 1.301a12.81 12.81 0 00-2.667 2.17c-.306.331-.587.701-.88 1.058-.37-.09-.74-.242-1.11-.28-1.06-.077-1.952.293-2.654 1.097-.817.931-1.008 2.322-.472 3.432.37.791.97 1.327 1.773 1.659zM16.447 26.304h-3.19c0-1.441.434-2.73 1.301-3.878.906-1.2 2.105-1.978 3.56-2.335.294-.077.587-.102.88-.154.205-.012.409-.038.638-.05v3.215a3.218 3.218 0 00-3.19 3.202z"
      ></path>
      <path
        fill="#FDFDFD"
        d="M6.98 18.126c-.804-.332-1.404-.868-1.787-1.659-.536-1.11-.344-2.5.472-3.432.702-.804 1.595-1.174 2.654-1.097.37.025.74.178 1.11.28.69.357 1.225.868 1.557 1.57.906 1.913-.37 4.223-2.45 4.504a3.6 3.6 0 01-1.557-.166zm-.473-3.024a1.607 1.607 0 001.582 1.62 1.607 1.607 0 001.62-1.582 1.607 1.607 0 00-1.581-1.62c-.893 0-1.62.702-1.62 1.582z"
      ></path>
      <path
        fill="#0FB6AF"
        d="M19.65 29.507a3.186 3.186 0 01-3.19-3.203h2.96c.076 0 .153-.012.242-.012v-1.583h1.595c.025.664-.46 1.378-1.263 1.595h2.87c0 1.736-1.441 3.216-3.215 3.203z"
      ></path>
      <path
        fill="#1FBBB4"
        d="M21.244 24.71H19.65v-1.595a1.58 1.58 0 011.595 1.595z"
      ></path>
      <path
        fill="#7FD8D4"
        d="M20.81 32.62c.026-.013.064-.013.09-.025a.236.236 0 01-.09.025z"
      ></path>
      <path
        fill="#3FC5BF"
        d="M19.65 23.115v1.595h-1.43c-.115 0-.178.025-.166.153.051.344.179.663.421.931.255.28.587.421.932.523h-2.96a3.205 3.205 0 013.202-3.202z"
      ></path>
      <path
        fill="#313A43"
        d="M6.507 15.102c.013-.88.74-1.582 1.62-1.582.881.012 1.583.74 1.583 1.62a1.615 1.615 0 01-1.62 1.582 1.606 1.606 0 01-1.583-1.62z"
      ></path>
      <path
        fill="#1FBBB4"
        d="M19.407 26.304c-.357-.102-.69-.23-.932-.523a1.69 1.69 0 01-.42-.931c-.013-.128.05-.153.165-.153h1.43v1.582c-.09.025-.167.025-.243.025z"
      ></path>
    </svg>
  );
}
